import { useAccommodationOffers } from "~/applications/OfferSearch/Api/useAccommodationOffers";
import { useHotelPagesOfDestination } from "~/applications/OfferSearch/Api/useHotelPagesOfDestination";
import { AccommodationOffer } from "~/applications/OfferSearch/Domain/AccommodationOffer";
import { UnitGroup } from "~/applications/OfferSearch/Domain/UnitGroup";
import StayRequest from "~/core/StayRequest";
import { AVAILABLE_LOCALES } from "~/core/locale";
import { CancellationPolicyId } from "../Domain/CancellationPolicyId";

/**
 * Use cases
 *  1. SEO use case: no stayRequest in props
 *  2. Loading case: with stay request useAccommodationOffers is loading
 *  3. No offer: with stay request but not corresponding accommodation offers --> UI fallback as soldout
 *  4. Offer found: with an offer (soldout or not)
 */
export const useAccommodationOfferOfUnitGroup = (
  destinationId: string,
  stayRequest: StayRequest | undefined,
  unitGroup: UnitGroup,
  locale: AVAILABLE_LOCALES,
  cancellationPolicyId: CancellationPolicyId,
): AccommodationOffer | null | undefined => {
  const { hotelPages } = useHotelPagesOfDestination({
    destinationId,
    locale,
  });

  const { accommodationOffers } = useAccommodationOffers(
    hotelPages !== null && stayRequest
      ? {
          logePmsIds: hotelPages.map((onePagePage) => onePagePage.loge.pmsId),
          checkIn: stayRequest.checkIn,
          checkOut: stayRequest.checkOut,
          nbAdult: stayRequest.nbAdult,
          nbChildren: stayRequest.nbChildren,
          nbBabies: stayRequest.nbBabies,
          promoCode: stayRequest.promoCode,
          cancellationPolicyId: cancellationPolicyId,
        }
      : false,
  );

  // Case #2 and #1
  if (accommodationOffers === null) {
    return undefined;
  }

  const accommodationOffer = accommodationOffers.find(
    (oneAccommodationOffer) =>
      oneAccommodationOffer.unitGroupId === unitGroup.id,
  );

  // Case #3
  if (!accommodationOffer) {
    return null; // ????
  }

  // Case #4
  return accommodationOffer;
};
